import { cookieRef } from '@layouts/stores/config'
import { defineStore } from 'pinia'

/**
 * Admin Filters Store
 * Globale jaar- en archief-filter voor alle admin pagina's met kamp-gerelateerde data.
 *
 * - selectedYear: gekozen kampjaar (op basis van vzw_camps.start_date) of 'all'.
 * - showArchive : wanneer true ook reeds afgelopen kampen tonen (end_date < now).
 *
 * Persistentie via cookies (zelfde patroon als layoutConfigStore).
 */

export type AdminYearFilter = number | 'all'

export const ALL_YEARS: AdminYearFilter = 'all'

export const useAdminFiltersStore = defineStore('adminFilters', () => {
  const currentYear = new Date().getFullYear()

  const selectedYear = cookieRef<AdminYearFilter>('adminSelectedYear', currentYear)
  const showArchive = cookieRef<boolean>('adminShowArchive', false)

  const yearOptions = computed<{ title: string, value: AdminYearFilter }[]>(() => {
    const now = new Date().getFullYear()

    const years: { title: string, value: AdminYearFilter }[] = [
      { title: 'Alle jaren', value: 'all' },
    ]

    for (let y = now + 1; y >= now - 5; y--)
      years.push({ title: String(y), value: y })

    return years
  })

  /**
   * Returns query params suitable for inclusion in admin API calls via buildQueryString.
   * - When selectedYear is 'all' the year param is omitted.
   * - include_archive is only added when true (default on the server is false).
   */
  function toQueryParams(): Record<string, string | number | boolean | undefined> {
    const params: Record<string, string | number | boolean | undefined> = {}
    if (typeof selectedYear.value === 'number')
      params.year = selectedYear.value
    if (showArchive.value)
      params.include_archive = true

    return params
  }

  return {
    selectedYear,
    showArchive,
    yearOptions,
    toQueryParams,
  }
})
